import { useQuery } from '@tanstack/react-query';
import React, { useCallback } from 'react';
import { Box, Button, SimpleGrid, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { ArrowBackIcon } from '@chakra-ui/icons';
import { useNavigate } from 'react-router-dom';
import axios from '../../api/axios';
import { PlaygroundType } from '../../utils/types';
import Playground from '../Playground/Playground';

const Playgrounds = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const playgroundsQuery = useQuery({
    queryKey: ['playgrounds'],
    queryFn: () =>
      axios({ url: '/playgrounds' }).then((response) => response.data),
  });

  const {
    data: playgroundsData,
    error: playgroundsError,
    isLoading: playgroundsIsLoading,
  } = playgroundsQuery;

  const isPublishedPlaygrounds = Array.isArray(playgroundsData)
    ? playgroundsData.filter(
        (playground: PlaygroundType) => playground.isPublished,
      )
    : [];

  const handleGoBackClick = useCallback(() => {
    navigate('/');
  }, [navigate]);

  return (
    <Box p={4}>
      <Button
        colorScheme="teal"
        variant="outline"
        size="sm"
        leftIcon={<ArrowBackIcon />}
        onClick={handleGoBackClick}
      >
        {t('button.back')}
      </Button>
      <SimpleGrid minChildWidth="250px" spacing={4} pt={3}>
        {isPublishedPlaygrounds && Array.isArray(isPublishedPlaygrounds) ? (
          isPublishedPlaygrounds?.map((playground: PlaygroundType) => (
            <Playground
              id={playground.id}
              key={playground.address}
              name={playground.name}
              address={playground.address}
              latitude={playground.latitude}
              longitude={playground.longitude}
              equipments={playground.equipments}
              averageRating={playground.averageRating}
              totalReviews={playground.totalReviews}
              openingHours={playground.openingHours}
              isPublished={playground.isPublished}
            />
          ))
        ) : (
          <Text>{t('playgrounds.no_playgrounds')}</Text>
        )}
      </SimpleGrid>
    </Box>
  );
};

export default Playgrounds;
